import { Link } from 'react-router-dom'
import { useAuth } from '../contexts/AuthContext'

function BottomNav() {
  const { user } = useAuth()

  if (!user) {
    return null
  }

  return (
    <div className="bottom-nav">
      <Link to="/about">About</Link>
    </div>
  )
}

export default BottomNav
